import { Component, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';

@Component({
	selector: 'app-careskill-modal-detail',
	standalone: false,
	templateUrl: './careskill-modal-detail.component.html',
	styleUrl: './careskill-modal-detail.component.scss'
})
export class CareskillModalDetailComponent {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.pattern(this.NAME_PATTERN),
			Validators.maxLength(32)
		])
	});

	careSkill: CareSkill;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.careSkill ? this.careSkill.name : null
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.careSkill.name = this.formEdit.get('name').value;
		this.facade.careSkillService.updateCareSkill(this.careSkill).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteCareSkill(): void {
		this.facade.careSkillService
			.deleteCareSkill(this.careSkill.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.careSkillService.deleteCareSkill(this.careSkill.id).subscribe({
			next: (succ) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
			}
		});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
